import { ReactNode, useMemo } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { createDestinationDateAdapter } from "../../helpers/destinationDateAdapter";

export default function DestinationTimeProvider({ timeZone, children }: {
    timeZone: string;
    children: ReactNode;
}) {
    const adapter = useMemo(() => createDestinationDateAdapter(timeZone), [timeZone]);
    return <LocalizationProvider dateAdapter={adapter}>{children}</LocalizationProvider>;
}
